// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { VehicleFleetIcon, VehicleIcon } from '@moia-dev/pace-icons'
import { GlobalVehicleManagementAreaRoutes } from './GlobalVehicleManagementAreaRoutes'

export const GlobalVehicleManagementAreaNavigationIcon = VehicleFleetIcon

export const GlobalVehicleManagementAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={GlobalVehicleManagementAreaRoutes.route}
      Icon={VehicleIcon}
    />
  )
}
